'use client';

import Container from '@mui/material/Container';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import CloudIcon from '@mui/icons-material/Cloud';
import axios from 'axios';
import { useEffect, useState, useMemo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import SunnyIcon from '@mui/icons-material/Sunny';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import CloudySnowingIcon from '@mui/icons-material/CloudySnowing';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import LanguageIcon from '@mui/icons-material/Language';
import { MapContainer, TileLayer, useMapEvent } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  IconButton,
} from '@mui/material';

export default function GeneralContainer() {
  const [weatherData, setWeatherData] = useState({});
  const [suner, setsuner] = useState({ suner: '' });
  const [location, setLocation] = useState(null);
  const [len, setleng] = useState('en');
  const [DialogOpen, setDialogOpen] = useState(false);
  const [map, setMap] = useState({
    open: false,
    lat: 0,
    lon: 0,
    location: null,
  });

  const background = useMemo(() => {
    if (suner.suner === 'sunrise') {
      return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)';
    } else if (suner.suner === 'sunset') {
      return 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)';
    } else if (suner.suner === 'moon') {
      return 'linear-gradient(135deg, #2c3e50 0%, #000000 100%)';
    }
    return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'; // default background
  }, [suner.suner]);

  useEffect(() => {
    const fetchWeatherData = async (latitude, longitude) => {
      const API_KEY = 'a123af52f7e33505521be598a5bdcb1d';
      try {
        // 1. جلب بيانات الطقس
        const weatherRes = await axios.get(
          `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${API_KEY}&lang=${len}&units=metric`
        );

        // 2. جلب بيانات الموقع الجغرافي (إذا كنت تحتاجها من OpenCage)
        // ملاحظة: تأكد أن مفتاح OpenCage هو نفسه مفتاح OpenWeatherMap وإلا سيظهر خطأ 401
        const geoRes = await axios.get(
          `https://api.opencagedata.com/geocode/v1/json?q=${latitude}%2C+${longitude}&key=3bd4d37aa0ea4afdaf3d5ec42425a0fe&language=${len}`
        );

        // 3. تحديث الحالة مرة واحدة بكل البيانات
        setWeatherData({
          ...weatherRes.data,
          local: geoRes.data.results[0]?.components || {},
        });
      } catch (error) {
        console.error(
          'خطأ في جلب البيانات:',
          error.response?.data?.message || error.message
        );
      }
    };

    const getPosition = () => {
      if (location) {
        // إذا كان هناك موقع مختار يدوياً، نستخدمه فوراً
        fetchWeatherData(location.lat, location.lon);
      } else {
        // إذا لم يوجد، نطلب الموقع من المتصفح
        navigator.geolocation.getCurrentPosition(
          (position) => {
            fetchWeatherData(
              position.coords.latitude,
              position.coords.longitude
            );
          },
          (error) => {
            console.error('فشل الوصول للموقع الجغرافي', error);
          }
        );
      }
    };

    getPosition();
  }, [len, location]);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.style.direction = len === 'ar' ? 'rtl' : 'ltr';
    }
  }, [len]);

  useEffect(() => {
    const now = new Date();
    const now_sunrise = new Date(
      weatherData.sys ? weatherData.sys.sunrise * 1000 : 0
    );
    const now_sunset = new Date(
      weatherData.sys ? weatherData.sys.sunset * 1000 : 0
    );
    if (now === now_sunset) {
      setsuner({ suner: 'sunrise' });
      setTimeout(() => {
        setsuner({ suner: 'sun' });
      }, 600000);
    } else if (now === now_sunrise) {
      setsuner({ suner: 'sunset' });
      setTimeout(() => {
        setsuner({ suner: 'moon' });
      }, 600000);
    } else if (now > now_sunrise && now < now_sunset) {
      setsuner({ suner: 'sunrise' });
    } else if (now > now_sunset) {
      setsuner({ suner: 'moon' });
    }
  }, [weatherData]);

  const fulldate = new Date(weatherData.dt ? weatherData.dt * 1000 : 0);

  const mapPosition = useMemo(() => {
    if (weatherData.coord) {
      return [weatherData.coord.lat, weatherData.coord.lon];
    }
    return [51.505, -0.09];
  }, [weatherData]);

  const UseMapEvent = () => {
    useMapEvent('click', async (e) => {
      const { lat, lng } = e.latlng;
      try {
        const paylod = {
          lon: lng,
          lat: lat,
        };
        const response_1 = await axios.get(
          'https://api.opencagedata.com/geocode/v1/json?q=' +
            paylod.lat +
            '%2C+' +
            paylod.lon +
            '&key=3bd4d37aa0ea4afdaf3d5ec42425a0fe&language=' +
            len
        );
        const locationName = response_1.data.results[0].components
          ? response_1.data.results[0].components._normalized_city !== undefined
            ? response_1.data.results[0].components._normalized_city
            : response_1.data.results[0].components.state !== undefined
              ? response_1.data.results[0].components.state
              : response_1.data.results[0].components.body_of_water !==
                  undefined
                ? response_1.data.results[0].components.body_of_water
                : response_1.data.results[0].components.continent !== undefined
                  ? response_1.data.results[0].components.continent
                  : null
          : null;
        setMap({ open: true, lat: lat, lon: lng, location: locationName });
      } catch (error) {
        console.error('Error fetching weather data:', error);
      }
    });
    return null;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #f0f2f5, #dfe6e9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={24}
          sx={{
            background,
            color: 'white',
            borderRadius: '24px',
            overflow: 'hidden',
            transition: 'all 0.5s ease',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            border: '1px solid rgba(255, 255, 255, 0.18)',
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 4,
              }}
            >
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 800,
                    textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
                  }}
                >
                  {weatherData.local ? (
                    weatherData.local._normalized_city ||
                    weatherData.local.state ||
                    weatherData.local.body_of_water ||
                    weatherData.local.continent ||
                    '---'
                  ) : (
                    <CircularProgress size={24} color="inherit" />
                  )}
                </Typography>
                <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                  {fulldate.toLocaleDateString(
                    len === 'ar' ? 'ar-DZ' : 'en-US',
                    {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    }
                  )}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <IconButton
                  onClick={() => setDialogOpen(true)}
                  sx={{
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' },
                  }}
                >
                  <AddLocationIcon />
                </IconButton>
                <IconButton
                  onClick={() => setleng(len === 'ar' ? 'en' : 'ar')}
                  sx={{
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' },
                  }}
                >
                  <LanguageIcon />
                </IconButton>
              </Box>
            </Box>

            <Divider sx={{ mb: 4, backgroundColor: 'rgba(255,255,255,0.3)' }} />

            <Grid container spacing={3} sx={{ alignItems: 'center' }}>
              <Grid size={{ xs: 12, sm: 7 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                  {weatherData.main ? (
                    <>
                      <Typography
                        variant="h1"
                        sx={{
                          fontWeight: 900,
                          fontSize: { xs: '5rem', sm: '6rem' },
                          lineHeight: 1,
                        }}
                      >
                        {Math.round(weatherData.main.temp)}
                      </Typography>
                      <Typography variant="h3" sx={{ mt: 1, fontWeight: 300 }}>
                        °C
                      </Typography>
                    </>
                  ) : (
                    <CircularProgress color="inherit" />
                  )}
                </Box>

                <Box sx={{ mt: 2 }}>
                  <Typography
                    variant="h5"
                    sx={{ textTransform: 'capitalize', fontWeight: 500 }}
                  >
                    {weatherData.weather?.[0]?.description || (
                      <CircularProgress size={20} color="inherit" />
                    )}
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.8, mt: 0.5 }}>
                    {weatherData.main
                      ? len === 'ar'
                        ? `الصغرى ${Math.round(weatherData.main.temp_min)}° / الكبرى ${Math.round(weatherData.main.temp_max)}°`
                        : `L: ${Math.round(weatherData.main.temp_min)}° / H: ${Math.round(weatherData.main.temp_max)}°`
                      : null}
                  </Typography>
                </Box>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 5 }}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <Box
                  sx={{
                    filter: 'drop-shadow(0 0 10px rgba(255,255,255,0.5))',
                    animation: 'float 3s ease-in-out infinite',
                    '@keyframes float': {
                      '0%': {
                        transform: 'translateY(0px)',
                      },
                      '50%': {
                        transform: 'translateY(-10px)',
                      },
                      '100%': {
                        transform: 'translateY(0px)',
                      },
                    },
                  }}
             
                >
                  {weatherData.weather ? (
                    weatherData.weather[0].main === 'Clear' ? (
                      suner.suner === 'sunrise' ? (
                        <WbTwilightIcon
                          sx={{ fontSize: 120, color: '#FFD700' }}
                        />
                      ) : suner.suner === 'sun' ? (
                        <SunnyIcon sx={{ fontSize: 120, color: '#FF8C00' }} />
                      ) : suner.suner === 'sunset' ? (
                        <WbTwilightIcon
                          sx={{ fontSize: 120, color: '#FF4500' }}
                        />
                      ) : suner.suner === 'moon' ? (
                        <DarkModeIcon
                          sx={{ fontSize: 120, color: '#E0E0E0' }}
                        />
                      ) : (
                        <Brightness1Icon
                          sx={{ fontSize: 120, color: 'gold' }}
                        />
                      )
                    ) : weatherData.weather[0].main === 'Clouds' ? (
                      <CloudIcon sx={{ fontSize: 120, color: 'white' }} />
                    ) : weatherData.weather[0].main === 'Rain' ? (
                      <CloudySnowingIcon
                        sx={{ fontSize: 120, color: 'white' }}
                      />
                    ) : weatherData.weather[0].main === 'Snow' ? (
                      <CloudySnowingIcon
                        sx={{ fontSize: 120, color: 'white' }}
                      />
                    ) : weatherData.weather[0].main === 'Drizzle' ? (
                      <WaterDropIcon sx={{ fontSize: 120, color: '#87CEEB' }} />
                    ) : weatherData.weather[0].main === 'Thunderstorm' ? (
                      <ThunderstormIcon
                        sx={{ fontSize: 120, color: '#708090' }}
                      />
                    ) : (
                      <CircularProgress color="inherit" />
                    )
                  ) : (
                    <CircularProgress color="inherit" />
                  )}
                </Box>
              </Grid>
            </Grid>
          </CardContent>

          <Box
            sx={{
              p: 3,
              background: 'rgba(0,0,0,0.1)',
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" sx={{ display: 'block' }}>
                Humidity
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {weatherData.main?.humidity}%
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" sx={{ display: 'block' }}>
                Wind
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {weatherData.wind?.speed} m/s
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" sx={{ display: 'block' }}>
                Pressure
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {weatherData.main?.pressure} hPa
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>

      {/* Select Location Dialog */}
      <Dialog
        open={Boolean(DialogOpen)}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
        fullWidth
        slotProps={{ paper: { sx: { borderRadius: '20px' } } }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              {len === 'ar' ? 'اختر موقعك' : 'Select Your Location'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {len === 'ar'
                ? 'انقر على الخريطة لتحديد موقع جديد'
                : 'Click on the map to choose a new location'}
            </Typography>
          </Box>
          <Box sx={{ width: '100%', height: '60vh' }}>
            <MapContainer
              center={mapPosition}
              zoom={4}
              style={{ height: '100%', width: '100%' }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                noWrap={true}
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <UseMapEvent />
            </MapContainer>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setDialogOpen(false)}
            variant="outlined"
            color="inherit"
          >
            {len === 'ar' ? 'إغلاق' : 'Close'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Selection Dialog */}
      <Dialog
        open={Boolean(map.open)}
        onClose={() => setMap({ ...map, open: false })}
        slotProps={{ paper: { sx: { borderRadius: '15px' } } }}
      >
        <DialogContent sx={{ textAlign: 'center', pt: 4 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            {len === 'ar' ? 'الموقع المختار:' : 'Selected Location:'}
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: 'bold', color: 'primary.main', mb: 1 }}
          >
            {map.location || <CircularProgress size={20} />}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3, justifyContent: 'center' }}>
          <Button
            onClick={() => setMap({ ...map, open: false })}
            variant="text"
            color="inherit"
          >
            {len === 'ar' ? 'إلغاء' : 'Cancel'}
          </Button>
          <Button
            onClick={() => {
              setDialogOpen(false);
              setLocation({ lat: map.lat, lon: map.lon });
              setMap({ ...map, open: false });
            }}
            variant="contained"
            disableElevation
            sx={{ px: 4, borderRadius: '10px' }}
          >
            {len === 'ar' ? 'تأكيد' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
